import React from 'react';
import type { FC } from 'react';
import { Box, Text, Link, Cart, Statistics } from '@wix/cli-ui-kit';
import { useProjectModel } from '../../../model.js';

export const NextSteps: FC = () => {
  const {
    model: {
      config: { appId },
    },
  } = useProjectModel();

  const homeUrl = `https://dev.wix.com/apps/${appId}/home?referralInfo=wix-cli`;
  const statisticsUrl = `https://dev.wix.com/apps/${appId}/statistics?referralInfo=wix-cli`;

  return (
    <Box flexDirection="column" gap={1}>
      <Text bold>Next Steps:</Text>
      <Text>
        <Statistics /> View your app reviews and statistics in the{' '}
        <Link url={statisticsUrl}>app dashboard</Link>
      </Text>
      <Text>
        <Cart /> Choose your distribution method from the{' '}
        <Link url={homeUrl}>app dashboard</Link>
      </Text>
    </Box>
  );
};
